import './Modal.scss'
import React from 'react'
import classNames from 'classnames'
import { Modal as BootstrapModal } from 'react-bootstrap'
import { Button, ButtonVariant } from '../Button/Button'
import { ModalProps as BootstrapModalProps } from 'react-bootstrap/Modal'
import { Divider } from '../Divider/Divider'

export interface ModalProps extends BootstrapModalProps {
  header?: React.ReactNode
  body?: React.ReactNode
  footer?: React.ReactNode
  showFooterActions?: boolean
  onFooterPrimaryAction?: () => void
  onFooterSecondaryAction?: () => void
  footerPrimaryActionLoading?: boolean
  footerPrimaryActionButtonVariant?: ButtonVariant
  footerPrimaryActionTitle?: string
  footerSecondaryActionLoading?: boolean
  footerSecondaryActionDisabled?: boolean
  footerSecondaryActionTitle?: string
  footerPrimaryActionDisabled?: boolean
  footerPrimaryActionDescription?: string
  footerClassName?: string
  headerClassName?: string
  bodyClassName?: string
  headerBodySeparator?: boolean
  hideSecondaryAction?: boolean
}

const Separator: React.FC = () => <Divider className='d-none d-md-block' />

export const Modal: React.FC<ModalProps> = ({
  header,
  body,
  footer,
  showFooterActions,
  onFooterPrimaryAction,
  onFooterSecondaryAction,
  footerPrimaryActionLoading = false,
  footerPrimaryActionButtonVariant = 'primary',
  footerPrimaryActionTitle = 'Save',
  footerSecondaryActionLoading = false,
  footerSecondaryActionDisabled = false,
  footerSecondaryActionTitle = 'Cancel',
  footerPrimaryActionDisabled = false,
  footerPrimaryActionDescription = '',
  footerClassName = '',
  headerClassName = '',
  bodyClassName = '',
  headerBodySeparator = false,
  hideSecondaryAction = false,
  ...rest
}) => {
  const { onHide } = rest
  const handleSecondaryAction = () => {
    if (onFooterSecondaryAction) {
      onFooterSecondaryAction()
    } else {
      onHide?.()
    }
  }

  const handlePrimaryAction = () => {
    onFooterPrimaryAction?.()
  }

  return (
    <BootstrapModal {...rest}>
      {header ? (
        <BootstrapModal.Header className={classNames(headerClassName, { 'p-4': headerBodySeparator })} closeButton={!!onHide}>
          {header}
        </BootstrapModal.Header>
      ) : null}
      {headerBodySeparator && header && body ? <Separator /> : null}
      {body ? <BootstrapModal.Body className={`${bodyClassName} ${headerBodySeparator ? 'p-4' : ''}`}>{body}</BootstrapModal.Body> : null}
      {footer || showFooterActions ? (
        <BootstrapModal.Footer className={footerClassName}>
          {footer ? footer : null}{' '}
          {showFooterActions ? (
            <div className='d-flex gap-3'>
              {hideSecondaryAction ? null : (
                <Button variant='secondary' disabled={footerSecondaryActionDisabled} onClick={handleSecondaryAction} loading={footerSecondaryActionLoading}>
                  {footerSecondaryActionTitle}
                </Button>
              )}
              <Button
                disabled={footerPrimaryActionDisabled}
                variant={footerPrimaryActionButtonVariant}
                onClick={handlePrimaryAction}
                loading={footerPrimaryActionLoading}
                title={footerPrimaryActionDescription}
              >
                {footerPrimaryActionTitle}
              </Button>
            </div>
          ) : null}
        </BootstrapModal.Footer>
      ) : null}
    </BootstrapModal>
  )
}
